<template>
    <vue-modal name="InfoErrors" :hideCloseBtn="true" :width="width">
        
        <div class="card mb-0" style="border: none">
            <div class="card-header" style="border-bottom: none; padding: 1rem 0px;">
                <h3 class="form-section">
                    <i class="icon-info"></i> Errors
                </h3>
                <div class="heading-elements" style="right: 0px;">
                    <button type="button" class="btn btn-warning" @click="closingModal(); $modals.hide('InfoErrors');">
                        <i style="color: #FFFFFF" class="icon-cross"></i>
                    </button>
                </div>
            </div>

            <div class="card-body">

                <!-- <div class="row">
                    <div class="col-md-12">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="jobss">{{$t('tasks.table.jobs')}}</label>
                                <div class="position-relative has-icon-left" v-for="(item, index) in $store.getters.getErrors()" :key="index">
                                    <div class="form-control-position"><i class="icon-cross hand"></i></div>
                                    <div class="form-control border-primary" style="background-color: #eceeef; min-height: 2em;">{{dataTask.jobs}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->


                <div class="row">
                    <div class="col-md-12" style="max-height: 60vh; overflow-x: hidden; overflow-y: auto;">

                        <div class="form-group mb-0" v-for="(item, index) in $store.getters.getErrors" :key="index">
                            <label for="error">
                                <span>{{index + 1}} - {{item.title}} <i class="icon-bin hand" @click="$store.commit('deleteError', index );"></i></span>
                            </label>
                            <div class="position-relative">
                                <!-- <textarea id="error" name="error" rows="3" class="form-control border-primary" v-model="item.text" disabled></textarea> -->
                                <div class="form-control border-primary" style="background-color: #eceeef; min-height: 2em;">{{item.text}}</div>
                            </div>
                        </div>

                    </div>
                </div>

                

            </div>
            <div class="card-footer" style="padding: 0.5em">
                <div class="row" >
                    <div class="d-flex justify-content-center">
                        <button type="button" class="btn btn-primary" @click="$store.commit('emptyErrors');">
                            <i style="color: #FFFFFF" class="icon-cross"></i> Clear errors
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </vue-modal>
</template>

<script>
  
  export default {
    name: "InfoErrors",
    data(){
        return {
            showinfo: false,
            width: null,          
        }
    },
    components: { },
    props:{
    },
    methods:{
        changeForm(){
            //document.getElementsByClassName('v-modal__heading').style.padding = '0px';
            /*setTimeout( () => {
                    $('.v-modal__heading').css({"padding":"0px"});
                },500 
            );*/
        },
        firstRun(){
            $('.v-modal__heading').css({"padding":"0px"});
        },
        closingModal(){
        },
    },
    computed: {
        
    },
    mounted(){
    },
    watch:{
        
    },
    created(){
        //this.width = window.innerWidth * 0.8;
        this.width = document.body.clientWidth * 0.9;
    },
  }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/modalErrors.vue